import React from 'react';
import {useTranslation} from 'react-i18next';
import {Row, Col} from 'reactstrap';
import {DatePicker} from '@/Form';

const TransferIn = () => {
  const {t: tr} = useTranslation();

  return (
    <Row>
      <Col md={12}>
        <label>{tr('report:transfer_in_effective_date')}</label>
        <Row>
          <Col md={2}>
            <DatePicker name='dateFrom' />
          </Col>
          <Col md={2} className='pl-1'>
            <DatePicker name='dateTo' />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default TransferIn;
